@if (appContext !== 'SRP') {
  <srp-loading></srp-loading>
}

<div [ngClass]="{ 'user-erc': isErcsUser }"><mat-toolbar class="header-toolbar" >
  <div class="header-container">
      <div id="global-loader">
        <div class="srp-spinner"></div>
        <p>Loading SRP....</p>
      </div>

      <srp-menu [pageContentLabels]="headerState().pageContentLabels" [appLinks]="headerState().appLinks"
        [appContext]="appContext"></srp-menu>

      <div class="header-left-image">
        <img (click)="redirectToLandingPage()" (keydown.enter)="redirectToLandingPage()" [src]="headerState().leftImage" height="25px" width="117px" alt="ServiceBox" />
      </div>

      @if(vehicleContext)
      { <srp-vehicle-details [vehicleContext]="vehicleContext"
        [pageContentLabels]="headerState().pageContentLabels"></srp-vehicle-details> }

  </div>
  <div class="header-container">

    <srp-user-profile [appContext]="appContext"></srp-user-profile>

    <srp-status-message [appContext]="appContext"></srp-status-message>

    <srp-mini-cart [pageContentLabels]="headerState().pageContentLabels" (errorResponse)="setErrorResponse($event)" [appContext]="appContext"></srp-mini-cart>
    <div class="header-right-image">
      <img [src]="headerState().rightImage" height="25px" width="106px" alt="Default Distrigo"
        class="logo-distrigo-right" />
    </div>
  </div>
</mat-toolbar>
</div>